/**
 * Wraps inline "[source: ...]" citations in article body copy with a
 * <span class="ss-citation"> so they can be styled as muted text.
 *
 * Pure client-side DOM transform: runs once after the page has rendered,
 * rewrites text nodes it finds in the rendered article content only.
 * Makes no network requests and never touches stored article content —
 * this is presentation-only, identical in nature to the theme's existing
 * <rte-formatter> runtime enhancement.
 */
(function () {
  var CITATION_PATTERN = /\[source:[^\]]*\]/gi;

  function wrapCitations(root) {
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var nodes = [];
    var node;

    while ((node = walker.nextNode())) {
      CITATION_PATTERN.lastIndex = 0;
      if (CITATION_PATTERN.test(node.nodeValue)) {
        nodes.push(node);
      }
    }

    nodes.forEach(function (textNode) {
      var text = textNode.nodeValue;
      var frag = document.createDocumentFragment();
      var lastIndex = 0;
      var match;

      CITATION_PATTERN.lastIndex = 0;
      while ((match = CITATION_PATTERN.exec(text))) {
        if (match.index > lastIndex) {
          frag.appendChild(document.createTextNode(text.slice(lastIndex, match.index)));
        }
        var span = document.createElement('span');
        span.className = 'ss-citation';
        span.textContent = match[0];
        frag.appendChild(span);
        lastIndex = match.index + match[0].length;
      }
      if (lastIndex < text.length) {
        frag.appendChild(document.createTextNode(text.slice(lastIndex)));
      }

      textNode.parentNode.replaceChild(frag, textNode);
    });
  }

  function init() {
    document
      .querySelectorAll('.ss-blog-post .blog-post-content, .ss-collection-info__description')
      .forEach(function (el) {
        wrapCitations(el);
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
